import { Observable } from '../utilities/Observable';

export class UserInfo {
  static instance;

  constructor(data) {
    if (UserInfo.instance) {
      return UserInfo.instance;
    }

    this._data = new Observable(data);
    UserInfo.instance = this;
  }

  get isLogged() {
    return this._data.value.isLogged;
  }

  get country() {
    return this._data.value.country;
  }

  get data() {
    return this._data.value;
  }

  set data(newData) {
    this._data.value = newData;
  }

  addObserver(callback) {
    this._data.addObserver(callback);
  }

  onDataReady(callback) {
    this._data.addOnDataReady(callback);
  }

  async isLoggedAsync() {
    return new Promise((resolve) => {
      this._data.addOnDataReady((data) => {
        resolve(Boolean(data.isLogged));
      });
    });
  }
}
